import React, { PropTypes, PureComponent } from 'react';
import Experiment from 'react-ab-test/lib/Experiment';
import Variant from 'react-ab-test/lib/Variant';


import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import cn from 'classnames';

import { BackArrow, Button, Field, Label, Logo, Input, Email, Phone, Toast, Select } from '../shared';
import styles from './styles.scss';
import messages from './i18n';

import { loadSegment } from '../../../lib/segment';

export class SignUpAccount extends PureComponent {
  constructor(props) {
    super(props);
    const options = [
      { label: props.intl.formatMessage(messages.signUpCount5Less), value: 1 },
      { label: props.intl.formatMessage(messages.signUpCount15Less), value: 6 },
      { label: props.intl.formatMessage(messages.signUpCount25Less), value: 16 },
      { label: props.intl.formatMessage(messages.signUpCount100Less), value: 26 },
      { label: props.intl.formatMessage(messages.signUpCount100Plus), value: 100 },
    ];

    /**
     * For whatever reason this should not be true when
     * this page loads.
     */
    props.signUpWorking(false);

    if (window.analytics && window.analytics.track) {
      window.analytics.track('time-clock-opened');
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      fadeOutHeader: false, fadeAndScaleOutBody: false, blur: false, options,
    };
  }

  componentDidMount() {
    loadSegment();
    this.setState({ fadeOutHeader: false });
    this.setState({ fadeAndScaleOutBody: false });
    this.setState({ blur: false });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ blur: Boolean(nextProps.signUp.toast) });
  }

  componentWillUpdate(props) {
    const { signUp, signUpValidForm } = props;
    const {
      validForm, name, email, phone, password, businessName, staffCount,
    } = signUp;
    if (!validForm &&
      (name.valid && email.valid && phone.valid && password.valid &&
        businessName.valid && (staffCount.value > 0))) {
      return signUpValidForm(true);
    }
    if (validForm &&
      (!name.valid || !email.valid || !phone.valid || !password.valid ||
        !businessName.valid || !(staffCount.value > 0))) {
      return signUpValidForm(false);
    }
    return null;
  }

  handleSubmit() {
    this.props.signUpCreateAccount(this.props.signUp);
    this.experimentRef.win();
  }


  render() {
    const { signUp, signUpSetField, signUpSetPhone } = this.props;
    const {
      name, email, phone, password, businessName,
    } = signUp;
    const { toast } = this.props.signUp;
    let toastView;
    if (toast) {
      toastView = <Toast {...this.props} />;
    }

    return (
      <div
        className={cn(styles.view, {
          [styles.fadeAndScaleOutBody]: this.props.complete,
        })}
      >
        <div
          className={cn(
            styles.header,
            { [styles.fadeOutHeader]: this.state.fadeOutHeader },
            { [styles.blur]: this.state.blur },
          )}
        >
          <BackArrow
            destination="/user"
          />
          <Logo className={styles.logo} />
        </div>
        <div
          className={cn(
            styles.layout,
            { [styles.fadeAndScaleOutBody]: this.state.fadeAndScaleOutBody },
            { [styles.blur]: this.state.blur },
          )}
        >
          <Field>
            <Label label={this.props.intl.formatMessage(messages.name)} />
            <Input
              value={name.value || ''}
              type="text"
              tabIndex={0}
              onChange={value => signUpSetField(['name', 'value'], value)}
              onValidation={value => signUpSetField(['name', 'valid'], value)}
              error={this.props.intl.formatMessage(messages.nameError)}
            />
          </Field>

          <Field>
            <Label label={this.props.intl.formatMessage(messages.email)} />
            <Email
              value={email.value || ''}
              tabIndex={0}
              onChange={value => signUpSetField(['email', 'value'], value)}
              onValidation={value => signUpSetField(['email', 'valid'], value)}
              placeholder={this.props.intl.formatMessage(messages.emailPlaceholder)}
              error={
                <p>
                  <span><FormattedMessage {...messages.validEmailError} /></span>
                  <Link className={styles.link} to="/setup" tabIndex="-1">
                    <FormattedMessage {...messages.alreadyHaveAccount} />
                  </Link>
                </p>
              }
              valid={email.valid}
            />
          </Field>

          <Field>
            <Label label={this.props.intl.formatMessage(messages.phone)} />
            <Phone
              defaultCountry="us"
              preferredCountries={['au', 'nz', 'us', 'ca', 'de']}
              value={phone.value || ''}
              tabIndex={0}
              onChange={value => signUpSetPhone({ value })}
              onValidation={value => signUpSetField(['phone', 'valid'], value)}
              placeholder={this.props.intl.formatMessage(messages.phonePlaceholder)}
              error={this.props.intl.formatMessage(messages.phoneError)}
            />
          </Field>

          <Field>
            <Label
              type="password"
              label={this.props.intl.formatMessage(messages.password)}
              className={styles.label}
            />
            <Input
              value={password.value || ''}
              type="password"
              tabIndex={0}
              onChange={value => signUpSetField(['password', 'value'], value)}
              onValidation={value => signUpSetField(['password', 'valid'], value)}
              placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
              error={this.props.intl.formatMessage(messages.passwordError)}
            />
          </Field>

          <Field className={styles.outerField}>
            <div className={styles.businessNameField}>
              <Label label={this.props.intl.formatMessage(messages.businessName)} />
              <Input
                value={businessName.value || ''}
                type="text"
                tabIndex={0}
                onChange={value => signUpSetField(['businessName', 'value'], value)}
                onValidation={value => signUpSetField(['businessName', 'valid'], value)}
                error={this.props.intl.formatMessage(messages.businessNameError)}
              />
            </div>
            <div className={styles.staffField}>
              <Label label={this.props.intl.formatMessage(messages.staff)} />
              <Select
                options={this.state.options}
                placeholder={this.props.intl.formatMessage(messages.selectStaff)}
                onChange={value => signUpSetField(['staffCount', 'value'], value)}
                onValidation={value => signUpSetField(['staffCount', 'valid'], value)}
                error={this.props.intl.formatMessage(messages.staffError)}
              />
            </div>
          </Field>

          <Field className={styles.termsContainer}>
            <div className={styles.terms}>
              <FormattedMessage
                {...messages.tAndC}
                values={{
                  terms: (
                    <a className={styles.link} href="https://www.tanda.co/terms-conditions/">
                      <nobr>{this.props.intl.formatMessage(messages.terms)}</nobr>
                    </a>
                  ),
                  privacy: (
                    <a className={styles.link} href="https://www.tanda.co/privacy/">
                      <nobr>{this.props.intl.formatMessage(messages.privacy)}</nobr>
                    </a>
                  ),
                }}
              />
            </div>
          </Field>

          <div className={styles.signUpContainer}>
            {/* eslint-disable */}
            <Experiment ref={el => this.experimentRef = el} name="signup-form-button-text">
              {/* eslint-disable */}
              <Variant name="sign-up">
                <Button
                  label={this.props.intl.formatMessage(messages.signUp)}
                  onClick={this.handleSubmit}
                  primary
                  loading={this.props.signUp.working}
                  disabled={!this.props.signUp.validForm || this.props.signUp.working}
                />
              </Variant>
              <Variant name="free-trial">
                <div className={styles.freeTrial}>
                  {this.props.intl.formatMessage(messages.freeTrialLabel)}
                </div>
                <Button
                  label={this.props.intl.formatMessage(messages.freeTrialButton)}
                  onClick={this.handleSubmit}
                  primary
                  loading={this.props.signUp.working}
                  disabled={!this.props.signUp.validForm || this.props.signUp.working}
                />
              </Variant>
            </Experiment>
          </div>
        </div>
        {toastView}
      </div>
    );
  }
}

SignUpAccount.propTypes = {
  signUpCreateAccount: PropTypes.func,
  signUpValidForm: PropTypes.func,
  signUpSetField: PropTypes.func,
  signUpWorking: PropTypes.func,
  signUp: PropTypes.shape({
    validForm: PropTypes.bool.isRequired,
    name: PropTypes.shape.isRequired,
    email: PropTypes.shape.isRequired,
    phone: PropTypes.shape.isRequired,
    password: PropTypes.shape.isRequired,
    businessName: PropTypes.shape.isRequired,
    staffCount: PropTypes.shape.isRequired,
    complete: PropTypes.shape.isRequired,
    working: PropTypes.shape.isRequired,
  }),
};

export default injectIntl(SignUpAccount);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_account/index.jsx